// * Only used in client-app.
export enum GESStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable', // no GES instance available
  FULL = 'full' // each GES support X number of matches, all GES are fully occupied by matches
}

export enum LobbyStatus {
  WAITING = 'waiting',
  PLAYING = 'playing',
  FINISHED = 'finished',
  IN_QUEUE = 'in_queue'
}
